module.exports = __webpack_public_path__ + "static/media/peligro.ba669982.png";